/**------------- Menu Small constants -------------**/

/*  General  */
export const MENU_SMALL_CONTAINER_CLASS_NAME =
	"menu-container-small";
export const MENU_SMALL_CLOSE_OUTLINE_CLASS_NAME =
	"close-outline";
export const MENU_SMALL_CHILDREN_ITEM_CLASS_NAME =
	"ant-menu-item-child";

/*  Style  */
export const MENU_SMALL_DRAWER_PLACEMENT = "right";

/*  Hamburger Button  */
export const HAMBURGER_BUTTON_CLASS_NAME =
	"hamburger-button";
export const HAMBURGER_BUTTON_SHAPE = "circle";
